"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPhoneNumberCreateDto = instanceOfPhoneNumberCreateDto;
exports.PhoneNumberCreateDtoFromJSON = PhoneNumberCreateDtoFromJSON;
exports.PhoneNumberCreateDtoFromJSONTyped = PhoneNumberCreateDtoFromJSONTyped;
exports.PhoneNumberCreateDtoToJSON = PhoneNumberCreateDtoToJSON;
exports.PhoneNumberCreateDtoToJSONTyped = PhoneNumberCreateDtoToJSONTyped;
/**
 * Check if a given object implements the PhoneNumberCreateDto interface.
 */
function instanceOfPhoneNumberCreateDto(value) {
    if (!('number' in value) || value['number'] === undefined)
        return false;
    return true;
}
function PhoneNumberCreateDtoFromJSON(json) {
    return PhoneNumberCreateDtoFromJSONTyped(json, false);
}
function PhoneNumberCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'number': json['number'],
        'extension': json['extension'] == null ? undefined : json['extension'],
        'receiveSms': json['receiveSms'] == null ? undefined : json['receiveSms'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function PhoneNumberCreateDtoToJSON(json) {
    return PhoneNumberCreateDtoToJSONTyped(json, false);
}
function PhoneNumberCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'number': value['number'],
        'extension': value['extension'],
        'receiveSms': value['receiveSms'],
        'type': value['type'],
    };
}
//# sourceMappingURL=PhoneNumberCreateDto.js.map